/* =========================
   TYPES
========================= */

export type TrackData = {
  trackKey: [string, number] // [playlistId, trackIndex]
  track: string
  trackName: string
  trackImg: string
  trackArtist: string
  playlistTitle: string
  playlistLink: string
  trackTime: string
  type: string
  trackTimeElapsed: number
}

export type State = {
  trackData: TrackData
  isPlaying: boolean
}

/* =========================
   INITIAL STATE (solo datos base)
   -> se rellena desde helpers en reducer
========================= */

export const EMPTY_TRACK_DATA: TrackData = {
  trackKey: ["", 0],
  track: "",
  trackName: "",
  trackImg: "",
  trackArtist: "",
  playlistTitle: "",
  playlistLink: "",
  trackTime: "",
  type: "",
  trackTimeElapsed: 0,
}